var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.url || _vm.history.length > 2)?_c('button',{staticClass:"back-button",on:{"click":_vm.goBack}},[_c('svg-icon',{attrs:{"icon":"arrow-left"}}),_c('span',[_vm._v(_vm._s(_vm._f("upperCase")(_vm._text)))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }